<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background Overlay -->
    <div class="fixed inset-0 bg-[#D4D7DE] bg-opacity-75 transition-opacity backdrop-blur-sm"></div>
    <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class=" fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <div class="w-screen max-w-3xl px-2 py-2 bg-white h-screen overflow-scroll">
                    <!-- Modal Content -->
                    <div>
                        <form [formGroup]="driverFrom" (ngSubmit)="onSave()" class="mt-4 px-4">
                            <div class="flex justify-between">
                                <div>
                                    <h2 class="heading">
                                        General Information
                                    </h2>
                                    <p class="text-sm-light">
                                        (Read Only)
                                    </p>
                                </div>

                                <div>
                                    <button type="button" (click)="onCloseModal()"
                                        class="rounded-lg p-1 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
                                        <span class="sr-only">Close panel</span>
                                        <!-- Heroicon name: outline/x-mark -->
                                        <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none"
                                            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                            aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>

                            </div>

                            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                            <section class="grid gap-4 md:grid-cols-2">

                                <!-- firstName -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        First Name
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1 ">
                                            <input formControlName="firstName" type="text" readonly />
                                        </div>
                                        <div class="flex gap-1">



                                            <!-- Cross Button -->

                                            <button (click)="setControl(form.isFirstName, false)" [ngClass]="{
                                              'btn btn-danger': !form.isFirstName.value, 
                                              'btn-outline btn-outline-danger': form.isFirstName.value
                                            }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>

                                            <!-- tick Button -->
                                            <button (click)="setControl(form.isFirstName, true)" [ngClass]="{
                                              'btn btn-success': form.isFirstName.value, 
                                              'btn-outline btn-outline-success': !form.isFirstName.value
                                            }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                </svg>
                                            </button>



                                        </div>
                                    </div>
                                </div>

                                <!-- isLastName -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Last Name
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input formControlName="lastName" type="text" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button (click)="setControl(form.isLastName, false)" [ngClass]="{
                                                'btn btn-danger': !form.isLastName.value, 
                                                'btn-outline btn-outline-danger': form.isLastName.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>

                                            <!-- Success Button -->
                                            <button (click)="setControl(form.isLastName, true)" [ngClass]="{
                                                'btn btn-success': form.isLastName.value, 
                                                'btn-outline btn-outline-success': !form.isLastName.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <ng-container formGroupName="address">

                                    <!-- City -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            City
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input type="text" formControlName="city" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <!-- Danger Button -->
                                                <button (click)="setControl(address.get('isCity'), false)" [ngClass]="{
                                                  'btn btn-danger': !address.get('isCity')?.value,
                                                  'btn-outline btn-outline-danger': address.get('isCity')?.value
                                                }" class="px-2" type="button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                        fill="currentColor" class="size-5">
                                                        <path
                                                            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                    </svg>
                                                </button>

                                                <!-- Success Button -->
                                                <button (click)="setControl(address.get('isCity'), true)" [ngClass]="{
                                                  'btn btn-success': address.get('isCity')?.value,
                                                  'btn-outline btn-outline-success': !address.get('isCity')?.value
                                                }" class="px-2" type="button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                        fill="currentColor" class="size-5">
                                                        <path
                                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                    </svg>
                                                </button>

                                            </div>
                                        </div>
                                    </div>

                                    <!-- Address -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            Address
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input type="text" formControlName="name" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button (click)="setControl(address.get('isName'), false)" [ngClass]="{
                                                    'btn btn-danger': !address.get('isName')?.value,
                                                    'btn-outline btn-outline-danger': address.get('isName')?.value
                                                  }" class="px-2" type="button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                        fill="currentColor" class="size-5">
                                                        <path
                                                            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                    </svg>
                                                </button>

                                                <!-- Success Button -->
                                                <button (click)="setControl(address.get('isName'), true)" [ngClass]="{
                                                    'btn btn-success': address.get('isName')?.value,
                                                    'btn-outline btn-outline-success': !address.get('isName')?.value
                                                  }" class="px-2" type="button">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                        fill="currentColor" class="size-5">
                                                        <path
                                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </ng-container>
                                <!-- Cell Phone Number -->

                                <!-- isPhoneNumber -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Cell Phone Number
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input type="tel" formControlName="phoneNumber" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button (click)="setControl(form.isPhoneNumber, false)" [ngClass]="{
                                                'btn btn-danger': !form.isPhoneNumber.value, 
                                                'btn-outline btn-outline-danger': form.isPhoneNumber.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>

                                            <!-- tick Button -->
                                            <button (click)="setControl(form.isPhoneNumber, true)" [ngClass]="{
                                                'btn btn-success': form.isPhoneNumber.value, 
                                                'btn-outline btn-outline-success': !form.isPhoneNumber.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Contact Number
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input type="tel" formControlName="contactNumber" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button (click)="setControl(form.isContactNumber, false)" [ngClass]="{
                                                                                'btn btn-danger': !form.isContactNumber.value, 
                                                                                'btn-outline btn-outline-danger': form.isContactNumber.value
                                                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>
                                
                                            <!-- tick Button -->
                                            <button (click)="setControl(form.isContactNumber, true)" [ngClass]="{
                                                                                'btn btn-success': form.isContactNumber.value, 
                                                                                'btn-outline btn-outline-success': !form.isContactNumber.value
                                                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5">
                                                    <path
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Email -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Email
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input type="email" formControlName="email" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button (click)="setControl(form.isEmail, false)" [ngClass]="{
                                                'btn btn-danger': !form.isEmail.value, 
                                                'btn-outline btn-outline-danger': form.isEmail.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>

                                            <!-- tick Button -->
                                            <button (click)="setControl(form.isEmail, true)" [ngClass]="{
                                                'btn btn-success': form.isEmail.value, 
                                                'btn-outline btn-outline-success': !form.isEmail.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Profile -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Profile
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input type="text" value="profile-image-link.jpg" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button (click)="setControl(form.isProfileImageURL, false)" [ngClass]="{
                                                                                      'btn btn-danger': !form.isProfileImageURL.value, 
                                                                 'btn-outline btn-outline-danger': form.isProfileImageURL.value
                                                                }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>

                                            <!-- tick Button -->
                                            <button (click)="setControl(form.isProfileImageURL, true)"
                                                [ngClass]="{
                                                                                                                                                                                                                                                                'btn btn-success': form.isProfileImageURL.value, 
                                                                                                                                                                                                                                                                'btn-outline btn-outline-success': !form.isProfileImageURL.value
                                                                                                                                                                                                                                                              }"
                                                class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <div class="mt-4">
                                <h2 class="heading">
                                    Driver's Documents
                                </h2>
                                <p class="text-sm-light">
                                    (Read Only)
                                </p>
                            </div>

                            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

                            <section class="grid gap-4 md:grid-cols-2">
                                <ng-container formGroupName="driverLicense">
                                    <!-- Front of Driver's License -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            Front of Driver's License
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input type="text" value="" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button (click)="setControl(driverLicense.get('isImage'), false)" [ngClass]="{
                                                    'btn btn-danger': !driverLicense.get('isImage')?.value,
                                                    'btn-outline btn-outline-danger': driverLicense.get('isImage')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                      </svg>
                                                  </button>
  
                                                  <!-- Success Button -->
                                                  <button (click)="setControl(driverLicense.get('isImage'), true)" [ngClass]="{
                                                    'btn btn-success': driverLicense.get('isImage')?.value,
                                                    'btn-outline btn-outline-success': !driverLicense.get('isImage')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                      </svg>
                                                  </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- License Number -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            License Number
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input formControlName="number" type="text" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button (click)="setControl(driverLicense.get('isNumber'), false)" [ngClass]="{
                                                    'btn btn-danger': !driverLicense.get('isNumber')?.value,
                                                    'btn-outline btn-outline-danger': driverLicense.get('isNumber')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                      </svg>
                                                  </button>
  
                                                  <!-- Success Button -->
                                                  <button (click)="setControl(driverLicense.get('isNumber'), true)" [ngClass]="{
                                                    'btn btn-success': driverLicense.get('isNumber')?.value,
                                                    'btn-outline btn-outline-success': !driverLicense.get('isNumber')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                      </svg>
                                                  </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- License Issue Date -->

                                    <div class="space-y-1">
                                        <label class="subheading">
                                            License Issue Date
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input type="text" formControlName="issueDate" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button (click)="setControl(driverLicense.get('isIssueDate'), false)" [ngClass]="{
                                                    'btn btn-danger': !driverLicense.get('isIssueDate')?.value,
                                                    'btn-outline btn-outline-danger': driverLicense.get('isIssueDate')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                      </svg>
                                                  </button>
  
                                                  <!-- Success Button -->
                                                  <button (click)="setControl(driverLicense.get('isIssueDate'), true)" [ngClass]="{
                                                    'btn btn-success': driverLicense.get('isIssueDate')?.value,
                                                    'btn-outline btn-outline-success': !driverLicense.get('isIssueDate')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                      </svg>
                                                  </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- License Expiration Date -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            License Expiration Date
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input type="text" formControlName="expireDate" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button (click)="setControl(driverLicense.get('isExpireDate'), false)" [ngClass]="{
                                                    'btn btn-danger': !driverLicense.get('isExpireDate')?.value,
                                                    'btn-outline btn-outline-danger': driverLicense.get('isExpireDate')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                      </svg>
                                                  </button>
  
                                                  <!-- Success Button -->
                                                  <button (click)="setControl(driverLicense.get('isExpireDate'), true)" [ngClass]="{
                                                    'btn btn-success': driverLicense.get('isExpireDate')?.value,
                                                    'btn-outline btn-outline-success': !driverLicense.get('isExpireDate')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                      </svg>
                                                  </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- License State Issued -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            License State Issued
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input type="text" formControlName="stateIssue" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button (click)="setControl(driverLicense.get('isStateIssue'), false)" [ngClass]="{
                                                    'btn btn-danger': !driverLicense.get('isStateIssue')?.value,
                                                    'btn-outline btn-outline-danger': driverLicense.get('isStateIssue')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                      </svg>
                                                  </button>
  
                                                  <!-- Success Button -->
                                                  <button (click)="setControl(driverLicense.get('isStateIssue'), true)" [ngClass]="{
                                                    'btn btn-success': driverLicense.get('isStateIssue')?.value,
                                                    'btn-outline btn-outline-success': !driverLicense.get('isStateIssue')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                      </svg>
                                                  </button>
                                            </div>
                                        </div>
                                    </div>

                                </ng-container>
                                <!-- Date of Birth -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Date of Birth
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input type="text" formControlName="dob" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button (click)="setControl(form.isDob, false)" [ngClass]="{
                                                'btn btn-danger': !form.isDob.value, 
                                                'btn-outline btn-outline-danger': form.isDob.value
                                              }" class="px-2" type="button">
                                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                      fill="currentColor" class="size-5">
                                                      <path
                                                          d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                  </svg>
                                              </button>
  
                                              <!-- tick Button -->
                                              <button (click)="setControl(form.isDob, true)" [ngClass]="{
                                                'btn btn-success': form.isDob.value, 
                                                'btn-outline btn-outline-success': !form.isDob.value
                                              }" class="px-2" type="button">
                                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                      fill="currentColor" class="size-5">
                                                      <path
                                                          d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                  </svg>
                                              </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Languages Spoken -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Languages Spoken
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input type="text" formControlName="languageSpoken" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button (click)="setControl(form.isLanguageSpoken, false)" [ngClass]="{
                                                'btn btn-danger': !form.isLanguageSpoken.value, 
                                                'btn-outline btn-outline-danger': form.isLanguageSpoken.value
                                              }" class="px-2" type="button">
                                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                      fill="currentColor" class="size-5">
                                                      <path
                                                          d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                  </svg>
                                              </button>
  
                                              <!-- tick Button -->
                                              <button (click)="setControl(form.isLanguageSpoken, true)" [ngClass]="{
                                                'btn btn-success': form.isLanguageSpoken.value, 
                                                'btn-outline btn-outline-success': !form.isLanguageSpoken.value
                                              }" class="px-2" type="button">
                                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                      fill="currentColor" class="size-5">
                                                      <path
                                                          d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                  </svg>
                                              </button>
                                        </div>
                                    </div>
                                </div>


                                <ng-container formGroupName="examinations">

                                    <!-- Latest Physical Exam -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            Latest Physical Exam
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input type="text" formControlName="phyExamImage" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button (click)="setControl(examinations.get('isPhyExamImage'), false)" [ngClass]="{
                                                    'btn btn-danger': !examinations.get('isPhyExamImage')?.value,
                                                    'btn-outline btn-outline-danger': examinations.get('isPhyExamImage')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                      </svg>
                                                  </button>
  
                                                  <!-- Success Button -->
                                                  <button (click)="setControl(examinations.get('isPhyExamImage'), true)" [ngClass]="{
                                                    'btn btn-success': examinations.get('isPhyExamImage')?.value,
                                                    'btn-outline btn-outline-success': !examinations.get('isPhyExamImage')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                      </svg>
                                                  </button>
                                            </div>
                                        </div>
                                    </div>


                                    <!-- Latest Physical Exam Completion Date -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            Latest Physical Exam Completion Date
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input type="tel" formControlName="phyExamDate" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button (click)="setControl(examinations.get('isPhyExamDate'), false)" [ngClass]="{
                                                    'btn btn-danger': !examinations.get('isPhyExamDate')?.value,
                                                    'btn-outline btn-outline-danger': examinations.get('isPhyExamDate')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                      </svg>
                                                  </button>
  
                                                  <!-- Success Button -->
                                                  <button (click)="setControl(examinations.get('isPhyExamDate'), true)" [ngClass]="{
                                                    'btn btn-success': examinations.get('isPhyExamDate')?.value,
                                                    'btn-outline btn-outline-success': !examinations.get('isPhyExamDate')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                      </svg>
                                                  </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Drug Test -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            Drug Test
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input type="text" formControlName="drugTestImage" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button (click)="setControl(examinations.get('isDrugTestImage'), false)" [ngClass]="{
                                                    'btn btn-danger': !examinations.get('isDrugTestImage')?.value,
                                                    'btn-outline btn-outline-danger': examinations.get('isDrugTestImage')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                      </svg>
                                                  </button>
  
                                                  <!-- Success Button -->
                                                  <button (click)="setControl(examinations.get('isDrugTestImage'), true)" [ngClass]="{
                                                    'btn btn-success': examinations.get('isDrugTestImage')?.value,
                                                    'btn-outline btn-outline-success': !examinations.get('isDrugTestImage')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                      </svg>
                                                  </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Drug Date -->
                                    <div class="space-y-1">
                                        <label class="subheading">
                                            Drug Date
                                        </label>
                                        <div class="flex flex-1 gap-2">
                                            <div class="flex-1">
                                                <input type="text" formControlName="drugTestDate" readonly />
                                            </div>
                                            <div class="flex gap-1">
                                                <button (click)="setControl(examinations.get('isDrugTestDate'), false)" [ngClass]="{
                                                    'btn btn-danger': !examinations.get('isDrugTestDate')?.value,
                                                    'btn-outline btn-outline-danger': examinations.get('isDrugTestDate')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                      </svg>
                                                  </button>
  
                                                  <!-- Success Button -->
                                                  <button (click)="setControl(examinations.get('isDrugTestDate'), true)" [ngClass]="{
                                                    'btn btn-success': examinations.get('isDrugTestDate')?.value,
                                                    'btn-outline btn-outline-success': !examinations.get('isDrugTestDate')?.value
                                                  }" class="px-2" type="button">
                                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                          fill="currentColor" class="size-5">
                                                          <path
                                                              d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                      </svg>
                                                  </button>
                                            </div>
                                        </div>
                                    </div>

                                </ng-container>

                                <!-- abuse -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Convicted of child abuse or felony in 5 years?
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input type="text" formControlName="abuse" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button (click)="setControl(form.isAbuse, false)" [ngClass]="{
                                                'btn btn-danger': !form.isAbuse.value, 
                                                'btn-outline btn-outline-danger': form.isAbuse.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>

                                            <!-- Success Button -->
                                            <button (click)="setControl(form.isAbuse, true)" [ngClass]="{
                                                'btn btn-success': form.isAbuse.value, 
                                                'btn-outline btn-outline-success': !form.isAbuse.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- violation -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Any vehicle violations in 3 years?
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input type="text" formControlName="violations" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button (click)="setControl(form.isViolations, false)" [ngClass]="{
                                                'btn btn-danger': !form.isViolations.value, 
                                                'btn-outline btn-outline-danger': form.isViolations.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>

                                            <!-- Success Button -->
                                            <button (click)="setControl(form.isViolations, true)" [ngClass]="{
                                                'btn btn-success': form.isViolations.value, 
                                                'btn-outline btn-outline-success': !form.isViolations.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Counties Served -->
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Service Areas
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input type="text" formControlName="serviceAreas" readonly />
                                        </div>
                                        <div class="flex gap-1">
                                            <button (click)="setControl(form.isServiceAreas, false)" [ngClass]="{
                                                'btn btn-danger': !form.isServiceAreas.value, 
                                                'btn-outline btn-outline-danger': form.isServiceAreas.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                                                </svg>
                                            </button>

                                            <!-- Success Button -->
                                            <button (click)="setControl(form.isServiceAreas, true)" [ngClass]="{
                                                'btn btn-success': form.isServiceAreas.value, 
                                                'btn-outline btn-outline-success': !form.isServiceAreas.value
                                              }" class="px-2" type="button">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                    fill="currentColor" class="size-5">
                                                    <path
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </section>
                            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                            <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                                <div class="space-y-1 col-span-full">
                                    <label class="subheading">
                                        Following information are invalid and need to be resubmitted by the company.
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <button class="btn btn-primary">
                                            Send Information via Email
                                        </button>
                                    </div>
                                </div>
                            </section>
                            <div class="mt-4">
                                <h2 class="subheading">
                                    I have checked the information given and i hereby confirm that all data entered is
                                    valid and
                                    satisfactory for the purpose of compliance and billing of trip
                                </h2>
                            </div>
                            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                            <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                                <div class="space-y-1">
                                    <label class="subheading">
                                        Date
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <input type="date" />
                                        </div>
                                    </div>
                                </div>
                                <div class="space-y-1">
                                    <label class="subheading">
                                        User
                                    </label>
                                    <div class="flex flex-1 gap-2">
                                        <div class="flex-1">
                                            <select name="" id="">
                                                <option value="">-- Select User --</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                            <section class="flex justify-end gap-4">
                                <button class="btn-outline btn-outline-secondary">
                                    Approve
                                </button>
                                <button type="button" class="btn btn-secondary">
                                    Send Contract
                                </button>
                            </section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>